<!--
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 16:57:36
 * @Description: 
-->
<template>
    <NuxtLayout name="game-coat" 
        :top-height="`${height01 + height02}px`"
        @dom-sender="getGoatDom"
    >
        <!-- 👇背景内容 slot （可选） -->
        <!-- ▼ 需要有一个 v-if='任意值' 否则报错 -->
        <template #bgContent >
            <section
                v-if="iRoundIndex >= 0"
                class="game-background"
                :class="{
                    'moving-down': oStatus.isGroundGoDown,
                    'no-animation': !isShowAnimation,
                }"
                :style="{ '--move-to-center': sMoveToCenter }"
            >
                <article class="only-background" >
                    <figure class="w100 bg-up"/>
                    <figure class="w100 bg-down"/>
                    <figure class="w100 going-star"/>
                    <figure class="w100 going-star fast"/>
                </article>
                <!-- ▲渐变背景，▼白云、太阳、地面 -->
                <article class="ground-things"
                    v-show="oStatus.isGroundShowing"
                >
                    <figure class="w100 cloud" />
                    <img class="sun" src="./img/sun.png"/>
                    <figure class="w100 ground01" />
                    <figure class="w100 ground02" />
                    <img class="base" src="./img/base.png"/>
                </article>
                <!-- ▼下落的星球等 -->
                <!-- ▼ 需要有一个 v-if='任意值' 否则报错 -->
                <article class="the-wall" vvif="iRoundIndex >= 0">
                    <!-- ↓ 不套这个 <template> 就报错，囧 -->
                    <template v-for="(oPic) of aPicOnWall"
                        :key="oPic.overallIndex"
                    >
                        <img class="wall-pic going-down"
                            :src="oPic.sUrl"
                            :style="{
                                'opacity': oPic.opacity || 1,
                                '--scale': oPic.scale || 1,
                                '--speed': oPic.speed || 1,
                                '--left-move': (oPic.lateralMove || 0) + '%',
                                'z-index': oPic.zIndex,
                            }"
                        />
                    </template>
                </article>
            </section>
            <!-- ▲底层背景-->
            <!-- ▼飞机 -->
            <section
                v-if="iRoundIndex >= 0"
                class="center-box"
                :style="{ '--move-to-center': sMoveToCenter }"
            >
                <!-- 通过 ▼template 实现重新加载的效果 -->
                <template v-if="oStatus.hasCrashed === false">
                    <!-- ↓ 倒计时 -->
                    <CountDown
                        ref="oCountDown"
                        v-if="oStatus.showCownDown"
                    ></CountDown>
                    <figure class="plane-wrap"
                        :class="{'take-off': oStatus.isPlaneGoUp}"
                    >
                        <img class="exploding"
                            v-show="oAnimation.state === 'crash'"
                            :src="explodingGifAnim"
                        />
                        <!--
                            ↑ 爆炸图 ↓ 飞机图
                            上下两项互斥
                        -->
                        <div v-show="oAnimation.state !== 'crash'"
                            class="plane-pic"
                        >
                            <img class="jet" src="./img/jet.png"/>
                            <img src="./img/plane.png"/>
                        </div>
                        <!-- ↓ 尾气烟雾 -->
                        <Smoke class="smoke01"
                            v-if="isShowAnimation && oStatus.isGroundShowing"
                        ></Smoke>
                    </figure>
                </template>
                <!-- ▼分数 -->
                <div class="info-under-plane" >
                    <em v-show="oAnimation.coef > 0"
                        class="score"
                        :class="{'red-color': scoreBeRed}"
                    >
                        <span ref="coef"></span>X
                    </em>
                    <span class="cashout-self"
                        v-show="oRound.stoppedAt > 0"
                    >
                        <span class="words">
                            {{$t('crash.CashedOut')}}
                        </span>
                        <em class="multi" v-if="oRound.stoppedAt > 0">
                            {{ oRound.stoppedAt.toFixed(2) }}x
                        </em>
                    </span>
                    <ul class="cashout-users">
                        <li v-for="cur of oRound.cashoutUsers"
                            :key="cur._id"
                        >
                            <UserAvatar class="avatar" size='20px'></UserAvatar>
                            <span class="amount">
                                {{cur.iCashout.toFixed(8)}}
                                &nbsp;
                                {{cur.currency.toUpperCase()}}
                            </span>
                        </li>
                    </ul>
                </div>
                <span class="network" >
                    <span class="status-text">
                        {{$t('crash.NetworkStatus')}}
                    </span>
                    <i :class="`status-ball status-${iNetworkStatus}`"/>
                </span>
            </section>
        </template>
        <!--
            ▲ 飞机
            ✨ ✨ ✨ ↑ 以上为纯视觉效果  ✨ ✨ ✨ 
            ✨ ✨ ✨ ↑ 以上没有交互动作  ✨ ✨ ✨ 
            ▼ 上层的游戏操作区
        -->
        <!-- ↓ 关闭下方的 v-if 否则有 hydration 报错 -->
        <template #panel-left
            vvif="iRoundIndex >= 0"
        > 
            <CasinoBetOptionSection
                class="left-input-panal"
                v-model:bet-amount-modal-value="oForm.amount"
                v-model:is-submiting="disabledGamePanel"
                :isAuto="isAutoMode"
                :currency="inputCurrency"
                @change-mode="toChangeMode"
            >
                <template #bet-button>
                    <PlaceBetBtn
                        class="main-bet-btn"
                        @click="clickOnBetButton"
                    />
                </template>
            </CasinoBetOptionSection>

            <div class="additional-controls-crash mt-2" >
                <InputBoxAmount mode="multiple" suffix="x"
                    :disabled="iJoinMark > 0"
                    :min="aCashoutLimites.min"
                    :max="aCashoutLimites.max"
                    :tip="{max: $t(`minMax.max_coefficient`).replace('●', aCashoutLimites.max)}"
                    v-model="oForm.cashoutAt" 
                    :label="$t('CashoutAt')"
                />
                <ButtonGrayButton
                    :hide="['bottom']"
                    :disabled="iJoinMark > 0"
                    @click="cashoutAdjuster(1)"
                >
                    <IconSvgUse use="icon-arrow-up" width="16" height="16"/> 
                </ButtonGrayButton>
                <ButtonGrayButton
                    bald
                    :hide="['top']"
                    :disabled="iJoinMark > 0"
                    @click="cashoutAdjuster(-1)"
                >
                    <IconSvgUse use="icon-arrow-down" width="16" height="16"/> 
                </ButtonGrayButton>
            </div>
        </template>
        <!--
            左右分界
        -->
        <template #playing-area-right>
            <div class="game-info">
                <div class="history-at-top">
                    <Jackpot
                        :jackpotSize="globalStore?.jackpotSum['crash']"
                        @click="()=>jackpotControler(true)"
                    />
                    <!-- 左右分界 -->
                    <div class="history-right">
                        <label class="history-btn" >
                            <IconSvgUse use="icon-statistic-3" width="18" height="18"/>
                            {{ $t('History') }}
                            <q-menu :offset="[0, 8]"
                                :ref="el => oHistoryControl.oMenuBox = el"
                            >
                                <section class="crash-history" is-open="true">
                                    <div class="crash-history__title">
                                        Crash {{$t('crash.History')}}
                                    </div>
                                    <div class="crash-history__subtitle">
                                        <div class="coefficient coefficient_gray">1x +</div>
                                        <div class="coefficient coefficient_green">2x +</div>
                                        <div class="coefficient coefficient_red">10x +</div>
                                    </div>
                                    <button class="btn-close"
                                        @click="hideHistoryBox"
                                    >
                                        <span class="icon">
                                            <IconSvgUse use="icon-close" size="20px"/>
                                        </span>
                                    </button>
                                    <button class="btn-scroll"
                                        :class="{
                                            'btn-scroll_start': oHistoryControl.seeStart,
                                            'btn-scroll_end': !oHistoryControl.seeStart,
                                        }"
                                        @click="switchHistoryDataInShow"
                                    >
                                        <span class="icon">
                                            <IconSvgUse
                                                size="20px"
                                                :use="oHistoryControl.seeStart ? 'icon-arrow-left-small' : 'icon-arrow-right-small'"
                                            />
                                        </span>
                                    </button>
                                    <div class="crash-history__body">
                                        <div class="list"
                                            :class="{
                                                'list_start': oHistoryControl.seeStart,
                                                'list_end': !oHistoryControl.seeStart,
                                            }"
                                        >
                                            <div class="list__inner"
                                                :ref="el => oHistoryControl.oPillarBox = el"
                                            >
                                                <div class="marker"></div>
                                                <!-- ↓原版有50条记录 -->
                                                <ClientOnly>
                                                <Popper hover arrow
                                                    placement="top"
                                                    :style="oHistoryControl.oPoperStyle"
                                                    v-for="(cur, idx) of aHistoryToShow"
                                                    :key="idx"
                                                    class="tooltip"
                                                    offsetDistance="10"
                                                >
                                                    <span class="list__item"
                                                        :class="{
                                                            [cur.sPillarName]: true,
                                                        }"
                                                    ></span>
                                                    <template #content>
                                                        <time class="pillar-time">
                                                            {{ cur.sDate }}
                                                        </time>
                                                        <em class="pillar-multi" >
                                                            {{ cur.sMulti }}
                                                        </em>
                                                    </template>
                                                </Popper>
                                            </ClientOnly>
                                                <div class="marker"></div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </q-menu>
                        </label>
                        <ul class="history-list">
                            <ClientOnly>
                                <li v-for="(oHistory, idx) of aHistoryToShow.slice(0, 20)"
                                    :key="idx"
                                    :class="oHistory.sType"
                                    :name="oHistory.date"
                                >
                                    {{ oHistory.sMulti }}
                                </li>
                            </ClientOnly>
                        </ul>
                    </div>
                </div>
                <!-- ▲ 上方的历史横条 -->
                <!-- ▼ 所有玩家信息 -->
                <aside class="player-info"
                    :class="{'player-showing': bPlayerVisible}"
                >
                    <header class="info-header" >
                        <ClientOnly>
                            <span>
                                <IconSvgUse use="icon-online" width="22" height="22"/>
                                {{ oRound.aUserJoined.length }}
                            </span>
                            <span>
                                ${{ sSumOfAmount }}
                            </span>
                        </ClientOnly>
                    </header>
                    <!-- 上下分界 -->
                    <div class="info-list-wrap">
                        <ul 
                            :style="{'--height02': `${height02||0}px`}"
                        >
                            <ClientOnly>
                                <li v-for="cur of oRound.aUserJoined"
                                    :key="cur" 
                                    class="one-player" 
                                    :class="{stopped: !!cur.stopped}"
                                >
                                    <span class="player-name">
                                        {{ cur.user.name }}
                                    </span>
                                    <span class="player-status">
                                        <span v-if="cur.stopped > 0" class='stopped'>
                                            x{{ cur.iTimes.toFixed(2) }}
                                        </span>
                                        <span v-else class='status'>
                                            {{ cur.bang || 'betting' }}
                                        </span>
                                    </span>
                                    <span class="player-amount" :currency="cur.currency"> 
                                        <CurrentCoin
                                            class="w-[18px] flex coin"
                                            :name="cur.currency"
                                        >
                                        </CurrentCoin>
                                        <em class="amount-val">
                                            {{
                                                cur.stopped > 0
                                                ? (cur.amount * cur.iTimes).toFixed(2)
                                                : (cur.amount).toFixed(2)
                                            }}
                                        </em>
                                    </span>
                                </li>
                            </ClientOnly>
                        </ul>
                    </div>
                    <!-- ▼把手 -->
                    <div class="handler" @click="togglePlayerInfo"> 
                        <IconSvgUse
                            v-if="!bPlayerVisible"
                            use="icon-arrow-left"
                            class="arrow arrow-left"
                        /> 
                        <span class="left" >
                            <IconSvgUse use="icon-online" width="24" height="24"/>
                            <em>
                                <ClientOnly>
                                    {{ oRound.aUserJoined.length }}
                                </ClientOnly>
                            </em>
                        </span>
                        <IconSvgUse
                            v-if="bPlayerVisible"
                            use="icon-arrow-right"
                            class="arrow arrow-right"
                        />
                    </div>
                </aside>
            </div>
        </template>
    </NuxtLayout>
    <!--  -->

    <!-- 👇弹出窗口 -->
    <ModalJackpot
        :visible="oVisible.jackpotVisible"
        game="Crash"
        :update="() => oVisible.jackpotVisible = false"
    />
    <ModalWinJackpotHandler
        :gameName="'crash'"
        ref="jackpotHandler"
    />
    <!-- ↓ 自动下注的输入面板（弹窗） -->
    <CasinoAutoSection
        :is-fast="false"
        :is-submiting="oForm.isSubmiting"
        :is-auto="isAutoMode"
        v-model:amount="oForm.amount"
        :ref="el => oAutoDialog=el"
        :gameName="'crashGame'" 
    />
</template>

<script>
import CountDown from './compo/_countDown.vue';
import Smoke from './compo/_smoke.vue';
import Jackpot from './compo/_jackpot.vue';
import PlaceBetBtn from './compo/_placeBetBtn.vue';
import Popper from "vue3-popper";
// ↑ 组件
import useSettingsStore from '@/stores/settings';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
import useGlobalStore from '@/stores/global';
import { useGameHistoryStore } from '@/stores/cansino/gameHistory';
import { useRatesStore } from '@/stores/cansino/rates';
import {useUserStore} from '@/stores/user';
// ↑ stores
import {methods} from './js/crashGame.js';
import oScssVar from '~/common/style/game.module.scss';
import {createBettingForm, useBettingToolkit } from '~/common/js/bettingToolkit';
import {useCrashSocket} from '@/socket/game/crash';
import {useAutoBetToolKit} from '@/common/js/bettingToolkit/auto.ts';
import { useGameSocket } from '~/socket/game';
import { mapState } from 'pinia'
import explodingGif from '@/assets/imgs/exploding/exploding-gif.gif';
import { getGameApi } from '@/common/js/gameAbout';
import moment from 'moment';
import { showTips4BadAmountIfNeeded} from '@/common/js/betHelper';
export default defineComponent({
    name: 'crashGame',
    components: {
        CountDown,
        Smoke,
        Jackpot,
        PlaceBetBtn,
        Popper,
    },
    props: [],
    provide(){
        return {
            crash: this, // 如果 hilo: 'string' 则 string 不是响应式的
        };
    },
    data () {
        const oStatus = {
            isGroundGoDown: false, // 地面下降
            isPlaneGoUp: false, // 飞机上升
            hasCrashed: true, // 默认为 true 不显示飞机，收到后台消息后再显示
            isGroundShowing: false, // 地面可见性
            showCownDown: false,// 倒计时可见性
        };
        const oAnimation = {
            state: '', // fly, crash,
            name: '', // PREPARING_NEXT_ROUND, BETTING, (STOP_BETTING, SHOW_RESULT)
            total: 0, // 100, 200, 300
            coef: 0, // 1.0063, 1.4093, 
            hasStoppedBetting_: false, 
        };
        // 👇控制各种窗口可见性
        const oVisible = {
            statistics:false,
            fairness: false,
            rule: false,
            jackpotVisible: false,
        };
        const jackpotPercentData = [{"percent":"5%","bet_amount_pre":"0.00005","bet_amount_suf":"000","bet_currency":"BTC"},{"percent":"20%","bet_amount_pre":"0.0001","bet_amount_suf":"0000","bet_currency":"BTC"},{"percent":"50%","bet_amount_pre":"0.005","bet_amount_suf":"00000","bet_currency":"BTC"}];
        const oRound = {
            id: 0, // 每局游戏的 ID，在下注后后台返回
            stoppedAt: 0, // 提现倍数
            showSelfResult: false, // 显示当前用户提现倍数的提示气泡
            cashoutUsers: [], // 已经提现的用户列表
            aUserJoined: [], // 参加游戏的用户列表
            oUserJoined: {}, // 参加游戏的用户列表
            iCheckOutAt: 0, // 记录上次播放“其它玩家提现”的时间
        };
        return {
            gameHistoryStore: useGameHistoryStore(),
            joinStateStore: useJoinStateStore(),
            globalStore: useGlobalStore(),
            oSettingsStore: useSettingsStore(),
            rates: useRatesStore(), // 汇率信息
            // ↑ 一些 store ------------------------------------------
            timerForNetworkCheck: true, // 监网络状态的定时器  
            oHistoryControl: {
                oPoperStyle: {
                    '--popper-theme-background-color': '#202A39', 
                    '--popper-theme-background-color-hover': '#202A39', 
                    '--popper-theme-border-radius': '8px',
                    '--popper-theme-padding': '8px 12px',
                    '--popper-theme-box-shadow': '3px 6px 9px rgba(0, 0, 0, 0.35)',
                    margin: 0,
                    border: 'none',
                },
                seeStart: true, // 默认显示头部 start
                oPillarBox: null,
                oMenuBox: null,
            },
            iRoundIndex: 0, // 每次开局 + 1 
            oSelfRound: {}, // 当前用户的下注信息，mini 中后补（重载时为此赋值）
            oRound,
            oRound_: Object.freeze(deepCopy(oRound)), // 用于新开局时重新初始化
            jackpotPercentData,
            oVisible,
            oAnimation,
            aCashoutLimites: {
                min: 1.01,
                max: 9999.99,
            },
            oStatus,
            aPicOnWall: [],
            bPlayerVisible: false, // 控制玩家列表可见性
            oScreen: {
                iWithE: Number.parseInt(oScssVar.myWidthE),
                iWithB: Number.parseInt(oScssVar.myWidthB),
            },
            isAutoMode: false, // 自动模式开关 
            oAutoDialog: null, // 自动模式窗口 
            iJoinMark: 0, // 0-1-2：未下注，下注到本次，下注到下次
            oForm: createBettingForm({
                amount: 0,
                cashoutAt: 100,
                isSubmiting: false, // 状态为 false 则停止自动下注
            }),
            oToolKit: {}, // 工具包，稍后赋值
            iNetworkStatus: 0, // 网络状态
            MusicControler: {}, // 启动时被覆盖
            fnResolve: ()=>{}, // 将会被覆盖，用于自动模式返回游戏结果
            oBetResultPromise: {}, // 将被覆盖，用于从中取得游戏结果
            isPlanningToSotpAutoBet: false, // 计划终止自动模式
            bFirstLoadNotYet: true, // true 表示尚未完成首次加载 
            aSocketList: [],
            hashLastTimeUse: '',
            bCrashMounted: false,
            oCoatMainDom: null,
            oCoatMainHeight: 0,
            height01: 480,
            height02: 0,
        };
    },
    computed: {
        ...mapState(useUserStore, ['oUserStore']),
        inputCurrency(){
            // ↓ 大于 0 表示已经提现，不再显示特定的图标（用默认值当前币种即可）
            if (this.oSelfRound.stopped > 0) {
                return void 0;
            }
            // ↓ 返回了有效值时会显示这个币种的图标，否则显示默认币种图标
            return this.oSelfRound.currency;
        },
        disabledGamePanel:{
            get(){
                return this.iJoinMark > 0; 
            },
            set(newVal){
                console.log("newVal", newVal);
            },
        },
        sMoveToCenter(){
            if (!import.meta.client) return '0px';
            if (this.globalStore.innerWidth < this.oScreen.iWithB) {
                return '0px';
            }
            return '20px';
        },
        explodingGifAnim(){
            return explodingGif + `?t=${this.iRoundIndex}`;
        },
        // ↓ 是否显示动画
        isShowAnimation(){
            const {animation} = this.oSettingsStore.inhouseGames.crash;
            return !!animation;
        },
        // ↓ 顶部历史记录数据 
        aHistoryToShow(){
            let aNewest = this.joinStateStore.history.all.slice(0, 50);
            // console.log("time01:", aNewest[0]?.date); // time01: 2024-05-27T17:50:05Z
            let sFormat = 'MM/DD/YYYY, hh:mm A';
            const $i18n = useNuxtApp().$i18n;
            const locale = $i18n.locale.value;
            if (locale == 'cn'){
                sFormat = 'YYYY/MM/DD HH:mm';
            }
            const aResult = aNewest.map(cur => {
                const multiValue = Number(cur.multi);
                const iLevel = this.multi2Level(multiValue); 
                const oThisOne = {
                    date: cur.date,
                    sDate: moment(cur.date).format(sFormat), 
                    sMulti: multiValue.toFixed(2) + 'x', 
                    iLevel,
                    sType: ['red', 'green', 'white'][iLevel],
                    sPillarName: 'list__item_' + ['3', '2', '1'][iLevel],
                };
                return oThisOne;
            });
            return aResult;
        },
        // 👇所有玩家下注金额汇总
        sSumOfAmount(){
            const oRates = this.rates.usdtComaparisonCurrencyList;
            const aValList = Object.values(oRates);
            if (aValList.find(Boolean) == void 0) {
                return ''; // 汇率尚未加载 
            }
            const fResult = this.oRound.aUserJoined.reduce((result, cur)=>{
                const {amount, currency} = cur;
                const fRate = oRates[`usdt${currency}`]; // 之前曾取得到 undefined 
                let addon = 0;
                if (fRate > 0){
                    addon = amount / fRate;
                }else{
                    console.error(`注意，汇率信息缺失 usdt${currency} =`, fRate, deepCopy(oRates)); 
                }
                return result + addon;
            }, 0);
            return fResult.toFixed(2);
        },
        scoreBeRed(){
            if (
                (this.oAnimation.state === 'fly') || this.bFirstLoadNotYet
            ) return false;
            // ↑ 不能显示红色，↓ 按情况显示红色
            return (
                (this.oAnimation.state === 'crash')
                || this.oStatus.hasCrashed
            );
        },
    },
    watch: {
        // ↓ 似乎应再监听 game history, 因为 hisotry 数据到位时，之前必然已经取得了 joinStateStore，
        joinStateStore: {
            deep: true,
            immediate: true,
            handler(newVal){ // （页面加载时执行一次）
                if (
                    !newVal
                    || !newVal.bets?.length // 新增于 2024.04.16 
                    || !newVal.hash // ← 防止出错（因为真的出错过）
                    || !newVal.hasGameInfoLoaded // 
                    || newVal.hash == this.hashLastTimeUse // 以此确保不会重复 
                ) return;
                // console.log("重载 crash (watch)", ); 
                this.hashLastTimeUse = newVal.hash;
                this.oAnimation.name = newVal.state.name;
                const bets = deepCopy(newVal.bets);
                console.log("★2 Crash data loaded => 🥎", newVal.state?.name, bets.length); 
                const hasBetted = this.manageUsersJoin(bets);
                // 只有在用户确实下注时才设置gameRunning为true
                if (hasBetted) {
                    this.joinStateStore.gameRunning = true; // 设为"游戏进行中" 
                    showLastRoundLoadedInfo();
                } else {
                    // 用户没有下注，确保gameRunning为false
                    this.joinStateStore.gameRunning = false;
                }
            },
        },
        oForm:{
            deep: true,
            immediate: true,
            handler(newVal){ // （页面加载时执行一次）
                if (import.meta.server) return; 
                const crashMaxWin = Number(newVal.amount.beFixed(2)) * Number(newVal.cashoutAt)
                showTips4BadAmountIfNeeded(crashMaxWin)
            },
        }
    },
    ...{ // 生命周期
        async created () {
            if (import.meta.server) return;
            const { stopInfinity, startInfinity, } = useAutoBetToolKit(
                this.oForm,
                this.betForThisTurn,
            );
            Object.assign(this.oToolKit, {
                stopInfinity,
                startInfinity,
            });
        },
        // ↓ 不放在 created 中，放在稍晚些的 mounted 中执行
        mounted(){
            // 页面加载时重置状态，防止从之前的状态继承
            this.iJoinMark = 0;
            this.isPlanningToSotpAutoBet = false;
            
            useBettingToolkit(this.oForm); // 设定默认下注金额 
            this.setPictureBoxesArr();
            this.createMusicControler();
            // ↓ 用于接收游戏历史数据，用于插入到 all, mybets
            const {ON_GAME_HISTORY_ON_HISTORY, EMIT_GAME_JOIN} = useGameSocket(); 
            // ↓ 告知后台，浏览器需要接收飞行信息
            // ↓ 这是一个容错手段，防止其它位置的调用不成功等
            EMIT_GAME_JOIN('crash', {}, (res) => {
                console.log('join', res);
                const self = res.bets?.find(it => it.user._id == useUserStore().id);
                this.oForm.cashoutAt = self?.autoStop || 100
                this.oRound.id = self?._id;
                this.oRound.aUserJoined = res.bets?.map(it => ({ ...it, stop: it.stopped, iTimes: it.stopped })) || [];
                if (self) {
                    if(!self.stopped) {
                        this.iJoinMark = 1
                    } else  {
                        // 检查游戏是否真的已经结束，防止错误设置预约状态
                        const gameEnded = this.oAnimation.state === 'crash' || this.oAnimation.name === 'PREPARING_NEXT_ROUND';
                        if (gameEnded) {
                            this.iJoinMark = 2; // 游戏已结束，可以预约下局
                        } else {
                            this.iJoinMark = 0; // 游戏未结束，不设置预约
                        }
                    }
                } else {
                    this.iJoinMark = 0
                }
            });
            let {
                ON_CRASH_RUNNING,
                ON_CRASH_STATE,
                ON_CRASH_STOPPED,
            } = useCrashSocket();
            this.aSocketList[0]= ON_CRASH_RUNNING(data => this.orderReciever(data, 'games.crash.fly'));
            this.aSocketList[1]= ON_CRASH_STATE(data => this.orderReciever(data, 'games.crash.state'));
            this.aSocketList[2]= ON_CRASH_STOPPED(data => this.orderReciever(data, 'games.crash.stopped'));
            this.aSocketList[3]= ON_GAME_HISTORY_ON_HISTORY('crash', data => {
                // ↓ 需要深拷贝，防止多处订阅互相污染
                data &&= deepCopy(data);
                this.orderReciever(data, 'crashbethistory');
            });
            this.fnCheckNetwork();
            this.bCrashMounted = true; 
            this.observeGoatDom();
        },
        beforeUnmount(){
            console.log('\n\n🔝crash beforeUnmount');
            this.timerForNetworkCheck = false; // 关闭定时器
            
            // 先取消订阅，防止状态冲突
            this.aSocketList.forEach(curFn => { // 终止接收
                console.log("取消订阅", !!curFn);
                if (curFn) curFn();
            }); 
            
            // 退出游戏时清理后台状态，防止重新进入时自动开始
            const { EMIT_GAME_EXIT } = useGameSocket();
            EMIT_GAME_EXIT('crash');
            console.log('已调用EMIT_GAME_EXIT清理crash游戏状态');
            
            // 彻底重置所有游戏状态，防止状态残留
            this.iJoinMark = 0;
            this.isPlanningToSotpAutoBet = false;
            this.isAutoMode = false;
            this.oForm.isSubmiting = false;
            this.joinStateStore.gameRunning = false;
            
            // 重置自动选项store的状态
            const autoOptionStore = useAutoOptionStore();
            autoOptionStore.isAutoBetting = false;
            autoOptionStore.setState({
                number: '',
                stopOnProfit: '',
                stopOnLoss: '',
                maxBetAmount: '',
                onWin: '',
                onLoss: '',
            });
            
            this?.MusicControler?.toDestory?.();
        },
    },
    methods: {
        // ↓ 测试打印
        toLog(){
            console.log("调用游戏下注上限");
            const joinStateStore =  this.joinStateStore;
            const data = JSON.parse(JSON.stringify(joinStateStore.betttingLimits));
            console.log(data);
        },
        ...methods,
    },
});
</script>

<style lang='scss' scoped src="./style/crash.scss"></style>
<style lang='scss' scoped src="./style/crashHistory.scss"></style>
<style lang='scss' scoped src="./style/crashBackground.scss"></style>
<style lang='scss' scoped src="./style/crashCenterBox.scss"></style>
<style lang='scss' scoped src="./style/crashLeftPanel.scss"></style>

